import { ColumnState } from 'ag-grid-community';
import { DateRange } from 'react-day-picker';
import { create } from 'zustand';
import { WareHouseDto } from "src/dtos/warehouse/wareHouseDto";
import { defaultWMS1030_R01DetailDto, defaultWMS1030_R01HeaderDto, defaultWMS1030_R01LotDto, WMS1030_R01DetailDto, WMS1030_R01HeaderDto, WMS1030_R01LotDto } from './Dto_WMS1030_R01';
import { showWarning } from 'src/utils/toast/toastUtil';
import { getFutureWeekdayExceptTodayAndTomorrow } from 'src/utils/date/dateUtils';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';

export interface WMS1030_R01Filter {
	
	dateRange: DateRange | undefined;
	wmsOrderNo: string;
	customCd: string;
	customNm: string;
}
export interface Store_WMS1030_R01 {
	WMS1030_R01Filter: WMS1030_R01Filter;
	WMS1030_R01PastFilter: WMS1030_R01Filter;
	setWMS1030_R01Filter: (filter: Partial<Store_WMS1030_R01['WMS1030_R01Filter']>) => void;
	setWMS1030_R01PastFilter: (filter: Store_WMS1030_R01['WMS1030_R01PastFilter']) => void;
	
	// ====== 매출 리스트 및 선택/편집 ======
	WMS1030_R01List: WMS1030_R01HeaderDto[];
	setWMS1030_R01List: (dataList: WMS1030_R01HeaderDto[]) => void;

	editWMS1030_R01: WMS1030_R01HeaderDto | null;
	setEditWMS1030_R01: (editSale: WMS1030_R01HeaderDto | null) => void;

	selectedWMS1030_R01: WMS1030_R01HeaderDto | undefined;
	setSelectedWMS1030_R01: (data: WMS1030_R01HeaderDto | undefined) => void;
	initSelectedWMS1030_R01: () => void;

	// ====== 상세(디테일) 행 선택/삭제 관리 ======
	deletedWMS1030_R01DetailList: string[];
	setDeletedWMS1030_R01DetailList: (idList: string[]) => void;
	addDeletedWMS1030_R01DetailList: (idList: string[]) => void;
	removeDeletedWMS1030_R01DetailList: (idList?: string[]) => void;

	// ====== 매출 상세(디테일) 데이터 ======
	WMS1030_R01DetailList: WMS1030_R01DetailDto[];
	setWMS1030_R01DetailList: (data: WMS1030_R01DetailDto[]) => void;
	insertWMS1030_R01DetailList: (data: WMS1030_R01DetailDto[], index?: number) => void;
	removeWMS1030_R01DetailList: (index: number) => void;
	updateWMS1030_R01DetailList: (index: number, data: WMS1030_R01DetailDto) => void;

	// ====== 선택(디테일) 행 선택/삭제 관리 ======
	selectedWMS1030_R01DetailList: string[];
	setSelectedWMS1030_R01DetailList: (idList: string[]) => void;
	addSelectedWMS1030_R01DetailList: (idList: string[]) => void;
	removeSelectedWMS1030_R01DetailList: (idList?: string[]) => void;
	initSelectedWMS1030_R01DetailList: () => void;

	originalWMS1030_R01DetailList: WMS1030_R01DetailDto[];
	setOriginalWMS1030_R01DetailList: (data: WMS1030_R01DetailDto[]) => void;

	// ====== 입고 상세(lot) 데이터 ======
	WMS1030_R01LotMap: Map<string, WMS1030_R01LotDto[]>;
	setWMS1030_R01LotMap: (data: Map<string, WMS1030_R01LotDto[]>) => void;
	
	selectedItemCdForLot: string | null;
	setSelectedItemCdForLot: (itemCd: string | null) => void;
	
	// LotTable의 핸들러들을 위한 함수. 현재 선택된 아이템의 Lot 리스트를 업데이트합니다.
	setWMS1030_R01LotList: (data: WMS1030_R01LotDto[]) => void;

	insertWMS1030_R01LotList: (data: WMS1030_R01LotDto[], index?: number) => void;
	removeWMS1030_R01LotList: (valueIndex: number) => void;
	updateWMS1030_R01LotList: (valueIndex: number, data: WMS1030_R01LotDto) => void;

	// ====== 입고 상세선택(lot) 행 선택/삭제 관리 ======
	selectedWMS1030_R01LotList: string[];
	setSelectedWMS1030_R01LotList: (idList: string[]) => void;
	addSelectedWMS1030_R01LotList: (idList: string[]) => void;
	removeSelectedWMS1030_R01LotList: (idList?: string[]) => void;
	initSelectedWMS1030_R01LotList: () => void;

	// ====== 입고 상세(lot) 행 선택/삭제 관리 ======
	deletedWMS1030_R01LotList: string[];
	setDeletedWMS1030_R01LotList: (idList: string[]) => void;
	addDeletedWMS1030_R01LotList: (idList: string[]) => void;
	removeDeletedWMS1030_R01LotList: (idList?: string[]) => void;

	originalWMS1030_R01LotList: WMS1030_R01LotDto[];
	setOriginalWMS1030_R01LotList: (data: WMS1030_R01LotDto[]) => void;

	// ====== 컬럼 상태(그리드) ======
	columnState: ColumnState[] | null;
	setColumnState: (state: ColumnState[] | null) => void;
	detailColumnState: ColumnState[] | null;
	setDetailColumnState: (state: ColumnState[] | null) => void;
	lotColumnState: ColumnState[] | null;
	setLotColumnState: (state: ColumnState[] | null) => void;
	
	allCount: number;				setAllCount: (allCount: number) => void;

	transportComplete: boolean;		setTransportComplete: (transportComplete: boolean) => void;
	detailFetchTrigger: boolean;	setDetailFetchTrigger: (detailFetchTrigger: boolean) => void;
	lotFetchTrigger: boolean;		setLotFetchTrigger: (lotFetchTrigger: boolean) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;
	detailScrollTop: number | null;
	setDetailScrollTop: (top: number | null) => void;
	lotScrollTop: number | null;
	setLotScrollTop: (top: number | null) => void;

	// ====== 초기화 ======
	initData: () => void;

	// 창고 코드 필터링 (로직센터 & 자재창고 여부)
	warehouseCdListToUseList: (logicCenter: string) => WareHouseDto[];
	// 공통코드 로드 후 초기값 동기화
	syncInitialData: () => void;
}

export const defaultWMS1030_R01Filter : WMS1030_R01Filter = {
	
	dateRange: {
		from: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
		to: getFutureWeekdayExceptTodayAndTomorrow()
	},
	wmsOrderNo: '',
	customCd: '',
	customNm: ''
};

const getInitialWMS1030_R01HeaderDto = (): WMS1030_R01HeaderDto => {
	const { wmsCdList, warehouseCdList } = useCommonCodeStore.getState();
	return {
		...defaultWMS1030_R01HeaderDto,
		logicCenter: wmsCdList?.[0]?.minorCd || '',
		warehouseCd: warehouseCdList?.[0]?.warehouseCd || '',
	};
};

export const useWMS1030_R01Store = create<Store_WMS1030_R01>((set, get) => ({
	WMS1030_R01Filter: defaultWMS1030_R01Filter,
	WMS1030_R01PastFilter: defaultWMS1030_R01Filter,
	setWMS1030_R01Filter: (update) => set((state) => ({
		WMS1030_R01Filter: {
			...state.WMS1030_R01Filter,
			...update
		}
	})),
	setWMS1030_R01PastFilter: (filter: Store_WMS1030_R01['WMS1030_R01PastFilter']) => set((state) => {
		return {
			...state,
			WMS1030_R01PastFilter: filter
		}
	}),

	// ====== 매출 리스트 및 선택/편집 ======
	WMS1030_R01List: [],
	setWMS1030_R01List: (dataList: WMS1030_R01HeaderDto[]) => set((state) => {
		return {
			...state,
			WMS1030_R01List: dataList
		}
	}),

	editWMS1030_R01: getInitialWMS1030_R01HeaderDto(),
	setEditWMS1030_R01: (editSale: WMS1030_R01HeaderDto | null) => set((state) => {
		return {
			...state,
			editWMS1030_R01: editSale
		}
	}),

	selectedWMS1030_R01: undefined,
	
	setSelectedWMS1030_R01: (data: WMS1030_R01HeaderDto | undefined) => set((state) => {
		// 탭 전환 시 그리드 리마운트로 인한 중복 선택 이벤트(트리거 오작동) 방어
		if (state.selectedWMS1030_R01 === data) return state;

		return { 
			selectedWMS1030_R01: data, 
			selectedWMS1030_R01DetailList: [], deletedWMS1030_R01DetailList: [],
			selectedWMS1030_R01LotList: [], deletedWMS1030_R01LotList: [],
			detailFetchTrigger: true,
			detailScrollTop: null,
			lotScrollTop: null,
		};
	}),
	initSelectedWMS1030_R01: () => set({ 
		selectedWMS1030_R01: undefined, 
		editWMS1030_R01: getInitialWMS1030_R01HeaderDto(), 
		WMS1030_R01DetailList: [],
		detailFetchTrigger: false,
	}),

	// ====== 매출 상세(디테일) 데이터 ======
	WMS1030_R01DetailList: [],
	setWMS1030_R01DetailList: (data: WMS1030_R01DetailDto[]) => set((state) => {
		let newList: WMS1030_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			// console.log(index + '번째 행의 item.Index 정보: ' 
			// 	+ ' valueIndex : ' + item.valueIndex 
			// 	+ ' valueAndOrderIndex : ' + valueAndOrderIndex
			// 	+ ' orderIndex : ' + item.orderIndex 
			// 	+ ' orderIndexSeq : ' + item.orderIndexSeq);
			newList.push({ 
				//...defaultWMS1030_R01DetailDto,
				...item,
				valueIndex: item.valueIndex > 0 ? item.valueIndex : valueAndOrderIndex,
				orderIndex: item.orderIndex > -1 ? item.orderIndex : valueAndOrderIndex,
				orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			WMS1030_R01DetailList: newList
		}
	}),
	insertWMS1030_R01DetailList: (data: WMS1030_R01DetailDto[], index?: number) => set((state) => {
		let newWMS1030_R01DetailList = [...state.WMS1030_R01DetailList];

		let targetRowData = newWMS1030_R01DetailList.find(item => item.valueIndex === index);
		let targetOrderIndex = targetRowData?.orderIndex || 0;
		// 데이터에 orderIndex가 있으면 그것을 사용하고, 없으면 1 (index 파라미터는 배열 위치로만 사용)		

		const newOrderIndexSeq = (targetRowData?.orderIndexSeq || 0) + 1;
		// console.log('targetOrderIndex : ', targetOrderIndex);
		// console.log('newOrderIndexSeq : ', newOrderIndexSeq);
		let maxValueIndex = Math.max(0, ...newWMS1030_R01DetailList.map(item => item.valueIndex || 0)) + 1;

		// newSYS4100_R01List에서 targetOrderIndex인 행들을 빼내서 newOrderIndexSeq 기준으로 다시 정렬
		// newOrderIndexSeq 보다 orderIndexSeq가 작은 행들은 유지. 
		// newOrderIndexSeq 보다 orderIndexSeq가 큰 행들은 기존 orderIndexSeq 값에 1을 더해서 저장.
		const targetRows = newWMS1030_R01DetailList.filter(item => item.orderIndex === targetOrderIndex);
		targetRows.forEach(item => {
			if(item.orderIndexSeq < newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq;
			} else if(item.orderIndexSeq >= newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq + 1;
			}
		});

		// targetRows를 newSYS4100_R01List에 대체
		newWMS1030_R01DetailList = newWMS1030_R01DetailList.filter(item => item.orderIndex !== targetOrderIndex);
		newWMS1030_R01DetailList.push(...targetRows);
		
		//새 행을 생성해서 newOrderIndexSeq 값의 행을 저장
		const newData = data.map(item => ({ ...defaultWMS1030_R01DetailDto, ...item, 
			valueIndex: maxValueIndex++,
			orderIndex: targetOrderIndex,
			orderIndexSeq: newOrderIndexSeq
		}));
		if (index !== undefined) {
			newWMS1030_R01DetailList.splice(index, 0, ...newData);
		} else {
			newWMS1030_R01DetailList.push(...newData);
		}

		return {
			...state,
			WMS1030_R01DetailList: newWMS1030_R01DetailList
		}
	}),
	removeWMS1030_R01DetailList: (index: number) => set((state) => {
		const newWMS1030_R01DetailList = [...state.WMS1030_R01DetailList].filter((item) => item.valueIndex !== index);
		return {
			...state,
			WMS1030_R01DetailList: newWMS1030_R01DetailList
		}
	}),
	updateWMS1030_R01DetailList: (valueIndex: number, data: WMS1030_R01DetailDto) => set((state) => {
		const _WMS1030_R01DetailList = state.WMS1030_R01DetailList.map(item =>
			item.valueIndex === valueIndex ? data : item
		);
		return {
			...state,
			WMS1030_R01DetailList: _WMS1030_R01DetailList
		}
	}),
	
	// ====== 상세(디테일) 행 선택/삭제 관리 ======
	deletedWMS1030_R01DetailList: [],
	setDeletedWMS1030_R01DetailList: (idList: string[]) => set((state) => {
		return {
			...state,
			deletedWMS1030_R01DetailList: idList
		}
	}),
	addDeletedWMS1030_R01DetailList: (idList: string[]) => set((state) => {
		const _deletedDetailList = [...state.deletedWMS1030_R01DetailList];

		for(const valueIndex of idList) {
			const isInserted = state.WMS1030_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
			const isModified = state.WMS1030_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if(!isInserted && !isModified) {
				_deletedDetailList.push(valueIndex);
			}
		}
		
		return {
			...state,
			deletedWMS1030_R01DetailList: _deletedDetailList
		}
	}),
	removeDeletedWMS1030_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		deletedWMS1030_R01DetailList: [...state.deletedWMS1030_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),

	selectedWMS1030_R01DetailList: [],
	setSelectedWMS1030_R01DetailList: (idList: string[]) => set((state) => {
		const foundItem = state.WMS1030_R01DetailList.find(
			(item) => item.valueIndex.toString() === idList[0]
		);
		const firstItemKey = foundItem ? `${foundItem.itemCd}-${foundItem.itemStatus}` : null;

		return {
			...state,
			selectedWMS1030_R01DetailList: idList,
			selectedItemCdForLot: firstItemKey,
			lotScrollTop: null,
		}
	}),
	addSelectedWMS1030_R01DetailList: (idList: string[]) => set((state) => {
		const _selectedWMS1030_R01DetailList = [...state.selectedWMS1030_R01DetailList];
		if(idList.length > 0) {
			_selectedWMS1030_R01DetailList.push(...idList);
		}
		return {
			...state,
			selectedWMS1030_R01DetailList: _selectedWMS1030_R01DetailList
		}
	}),
	removeSelectedWMS1030_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		selectedWMS1030_R01DetailList: [...state.selectedWMS1030_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),
	initSelectedWMS1030_R01DetailList: () => set({ selectedWMS1030_R01DetailList: [] }),

	originalWMS1030_R01DetailList: [],
	setOriginalWMS1030_R01DetailList: (data: WMS1030_R01DetailDto[]) => set((state) => {
		let newList: WMS1030_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			newList.push({ 
				...defaultWMS1030_R01DetailDto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalWMS1030_R01DetailList: newList
		}
	}),

	// ====== 입고 상세(lot) 데이터 ======
	WMS1030_R01LotMap: new Map<string, WMS1030_R01LotDto[]>(),
	setWMS1030_R01LotMap: (data: Map<string, WMS1030_R01LotDto[]>) => set({ WMS1030_R01LotMap: data }),

	selectedItemCdForLot: null,
	setSelectedItemCdForLot: (itemCd) => set({ selectedItemCdForLot: itemCd }),

	setWMS1030_R01LotList: (data: WMS1030_R01LotDto[]) => set((state) => {
		const { WMS1030_R01LotMap, selectedItemCdForLot } = state;
		if (!selectedItemCdForLot) return state; // 선택된 아이템이 없으면 아무것도 하지 않음

		const newLotMap = new Map(WMS1030_R01LotMap);
		newLotMap.set(selectedItemCdForLot, data);

		return { WMS1030_R01LotMap: newLotMap };
	}),

	insertWMS1030_R01LotList: (data: WMS1030_R01LotDto[], index?: number) => set((state) => {
		const { WMS1030_R01LotMap, selectedItemCdForLot } = state;
		if (!selectedItemCdForLot) return state;

		const newLotMap = new Map(WMS1030_R01LotMap);
		let targetList = [...(newLotMap.get(selectedItemCdForLot) || [])];

		let targetRowData = targetList.find(item => item.valueIndex === index);
		let targetOrderIndex = targetRowData?.orderIndex || 0;
		// 데이터에 orderIndex가 있으면 그것을 사용하고, 없으면 1 (index 파라미터는 배열 위치로만 사용)		

		const newOrderIndexSeq = (targetRowData?.orderIndexSeq || 0) + 1;
		// console.log('targetOrderIndex : ', targetOrderIndex);
		// console.log('newOrderIndexSeq : ', newOrderIndexSeq);
		let maxValueIndex = Math.max(0, ...targetList.map(item => item.valueIndex || 0)) + 1;

		// newTargetList에서 targetOrderIndex인 행들을 빼내서 newOrderIndexSeq 기준으로 다시 정렬
		// newOrderIndexSeq 보다 orderIndexSeq가 작은 행들은 유지. 
		// newOrderIndexSeq 보다 orderIndexSeq가 큰 행들은 기존 orderIndexSeq 값에 1을 더해서 저장.
		const targetRows = targetList.filter(item => item.orderIndex === targetOrderIndex);
		targetRows.forEach(item => {
			if(item.orderIndexSeq < newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq;
			} else if(item.orderIndexSeq >= newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq + 1;
			}
		});

		// targetRows를 newSYS4100_R01List에 대체
		targetList = targetList.filter(item => item.orderIndex !== targetOrderIndex);
		targetList.push(...targetRows);
		
		//새 행을 생성해서 newOrderIndexSeq 값의 행을 저장
		const newData = data.map(item => ({ ...defaultWMS1030_R01LotDto, ...item, 
			valueIndex: maxValueIndex++,
			orderIndex: targetOrderIndex,
			orderIndexSeq: newOrderIndexSeq
		}));
		if (index !== undefined) {
			targetList.splice(index, 0, ...newData);
		} else {
			targetList.push(...newData);
		}
		
		newLotMap.set(selectedItemCdForLot, targetList);
		return { WMS1030_R01LotMap: newLotMap };
	}),

	removeWMS1030_R01LotList: (valueIndex: number) => set((state) => {
		const { WMS1030_R01LotMap, selectedItemCdForLot } = state;
		if (!selectedItemCdForLot) return state;

		const newLotMap = new Map(WMS1030_R01LotMap);
		const targetList = (newLotMap.get(selectedItemCdForLot) || []).filter(item => item.valueIndex !== valueIndex);
		
		newLotMap.set(selectedItemCdForLot, targetList);
		return { WMS1030_R01LotMap: newLotMap };
	}),

	updateWMS1030_R01LotList: (valueIndex: number, data: WMS1030_R01LotDto) => set((state) => {
		const { WMS1030_R01LotMap, selectedItemCdForLot } = state;
		if (!selectedItemCdForLot) return state;

		// inputOutQty가 유효한 숫자인지 확인하고, 아니면 0으로 설정
		if (typeof data.inputOutQty !== 'number' || isNaN(data.inputOutQty)) {
			showWarning('출고량은 숫자만 입력할 수 있습니다.');
			data.inputOutQty = 0;
		}
		if(data.inputOutQty > data.lotQty) {
			showWarning('출고량은 재고량보다 클 수 없습니다.');
			data.inputOutQty = data.lotQty;
		}
		if(data.inputOutQty < 0) {
			showWarning('출고량은 0보다 작을 수 없습니다.');
			data.inputOutQty = 0;
		}

		const newLotMap = new Map(WMS1030_R01LotMap);
		const targetList = (newLotMap.get(selectedItemCdForLot) || []).map(item =>
			item.valueIndex === valueIndex ? { ...data, isModified: Number(data.inputOutQty) > 0 ? true : false } : item
		);

		newLotMap.set(selectedItemCdForLot, targetList);
		return { WMS1030_R01LotMap: newLotMap };
	}),
	
	// ====== 입고 상세(lot) 행 선택/삭제 관리 ======
	deletedWMS1030_R01LotList: [],
	setDeletedWMS1030_R01LotList: (idList: string[]) => set((state) => {
		return {
			...state,
			deletedWMS1030_R01LotList: idList
		}
	}),
	addDeletedWMS1030_R01LotList: (idList: string[]) => set((state) => {
		const _deletedLotList = [...state.deletedWMS1030_R01LotList];
		const selectedItemKey = state.selectedItemCdForLot;
		const newWMS1030_R01LotList = [...state.WMS1030_R01LotMap.get(selectedItemKey!) || []];

		for(const valueIndex of idList) {
			const isInserted = newWMS1030_R01LotList.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
			const isModified = newWMS1030_R01LotList.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if(!isInserted && !isModified) {
				_deletedLotList.push(valueIndex);
			}
		}
		
		return {
			...state,
			deletedWMS1030_R01LotList: _deletedLotList,
		}
	}),
	removeDeletedWMS1030_R01LotList: (idList?: string[]) => set((state) => ({
		...state,
		deletedWMS1030_R01LotList: [...state.deletedWMS1030_R01LotList].filter(value => idList ? !idList.includes(value) : false)
	})),

	selectedWMS1030_R01LotList: [],
	setSelectedWMS1030_R01LotList: (idList: string[]) => set((state) => {
		return {
			...state,
			selectedWMS1030_R01LotList: idList,
		}
	}),
	addSelectedWMS1030_R01LotList: (idList: string[]) => set((state) => {
		const _selectedWMS1030_R01LotList = [...state.selectedWMS1030_R01LotList];
		if(idList.length > 0) {
			_selectedWMS1030_R01LotList.push(...idList);
		}
		return {
			...state,
			selectedWMS1030_R01LotList: _selectedWMS1030_R01LotList
		}
	}),
	removeSelectedWMS1030_R01LotList: (idList?: string[]) => set((state) => ({
		...state,
		selectedWMS1030_R01LotList: [...state.selectedWMS1030_R01LotList].filter(value => idList ? !idList.includes(value) : false)
	})),
	initSelectedWMS1030_R01LotList: () => set({ selectedWMS1030_R01LotList: [] }),	

	originalWMS1030_R01LotList: [],
	setOriginalWMS1030_R01LotList: (data: WMS1030_R01LotDto[]) => set((state) => {
		let newList: WMS1030_R01LotDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			newList.push({ 
				...defaultWMS1030_R01LotDto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalWMS1030_R01LotList: newList
		}
	}),

	// ====== 컬럼 상태(그리드) ======
	columnState: null,
	setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),
	detailColumnState: null,
	setDetailColumnState: (state: ColumnState[] | null) => set({ detailColumnState: state }),
	lotColumnState: null,
	setLotColumnState: (state: ColumnState[] | null) => set({ lotColumnState: state }),

	allCount: 0,					setAllCount: (allCount: number) => set({ allCount }),
						

	transportComplete: false,		setTransportComplete: (transportComplete: boolean) => set({ transportComplete }),
	detailFetchTrigger: false,		setDetailFetchTrigger: (detailFetchTrigger: boolean) => set({ detailFetchTrigger }),
	lotFetchTrigger: false,			setLotFetchTrigger: (lotFetchTrigger: boolean) => set({ lotFetchTrigger }),

	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),
	detailScrollTop: null,
	setDetailScrollTop: (top: number | null) => set({ detailScrollTop: top }),
	lotScrollTop: null,
	setLotScrollTop: (top: number | null) => set({ lotScrollTop: top }),

	// ====== 초기화 ======
	initData: () => set((state) => ({
		...state,
		WMS1030_R01Filter: defaultWMS1030_R01Filter,
		WMS1030_R01PastFilter: defaultWMS1030_R01Filter,
		WMS1030_R01List: [],
		selectedWMS1030_R01: undefined,
		WMS1030_R01DetailList: [],
		deletedWMS1030_R01DetailList: [],
		selectedWMS1030_R01DetailList: [],
		editWMS1030_R01: getInitialWMS1030_R01HeaderDto(),
		WMS1030_R01LotMap: new Map<string, WMS1030_R01LotDto[]>(),
		selectedItemCdForLot: null,
		originalWMS1030_R01LotList: [],
		deletedWMS1030_R01LotList: [],
		selectedWMS1030_R01LotList: [],
		allCount: 0,
		
		transportComplete: false,
		detailFetchTrigger: false,
		lotFetchTrigger: false,
		scrollTop: null,
		detailScrollTop: null,
		lotScrollTop: null,
	})),

	warehouseCdListToUseList: (logicCenter: string) => {
		const { warehouseCdList } = useCommonCodeStore.getState();
		const filteredList = warehouseCdList.filter(value => (value.logicCenter === logicCenter
			&& (value.goodsYn === 'Y' || value.productYn === 'Y')
		));
		
		if (filteredList.length === 0) {
			return [{ warehouseCd: '', warehouseNm: '' } as WareHouseDto];
		}
		
		return filteredList;
	},

	syncInitialData: () => {
		const { wmsCdList } = useCommonCodeStore.getState();
		const state = get();
		
		// 이미 값이 있거나 공통코드가 없으면 리턴
		if ((state.editWMS1030_R01?.logicCenter && state.editWMS1030_R01?.warehouseCd) || wmsCdList.length === 0) return;

		const defaultLogicCenter = wmsCdList?.[0]?.minorCd || '';
		
		// 스토어 내부 함수를 사용하여 유효한 창고 목록을 가져옴
		const availableWarehouses = state.warehouseCdListToUseList(defaultLogicCenter);
		const defaultWarehouseCd = availableWarehouses?.[0]?.warehouseCd || '';
		const defaultWarehouseNm = availableWarehouses?.[0]?.warehouseNm || '';

		set((state) => ({
			editWMS1030_R01: {
				...state.editWMS1030_R01!,
				logicCenter: defaultLogicCenter,
				warehouseCd: defaultWarehouseCd,
				warehouseNm: defaultWarehouseNm,
			}
		}));
	},

	
}));
